import styled from 'styled-components'

export const LayoutWrapper = styled.div`
  position: relative;
  height: 100%;
`

export const PageWrapper = styled.div`
  position: relative;
`

export const ContentWrapper = styled.div`
  position: relative;
  overflow: visible;
  height: 100%;
  width: 100%;
  .page {
    top: 0;
    height: 100%;
    width: 100%;
  }
  .page.entering,
  .page.entered {
    transition: opacity 1s 0.2s;
    position: relative;
    opacity: 1;
  }
  .page.exiting,
  .page.exited {
    transition: opacity 0s;
    position: absolute;
    opacity: 0;
  }
`
